import React from 'react';
import { Radio, UIText2, FormField, UIText1, UiKitRoot } from '@cian/ui-kit';

import styles from './styles.css';
import { useBaseField } from '../BaseField';
import { IField } from '../../types/calculator';

export const RadioField: React.FC<IField> = props => {
  const { field, fieldState } = useBaseField(props);

  if (!props.source) {
    return null;
  }

  const isError = fieldState.isDirty || fieldState.invalid;

  return (
    <FormField
      label={props.label}
      errorMessage={isError ? fieldState.error : undefined}
      required={!!props.validation?.required}
      withoutMargin
    >
      <div className={styles.wrapper}>
        {props.source.map(option => (
          <label className={styles.item} key={option.value}>
            <div className={styles.description}>
              <UIText1 color="black_100">{option.label}</UIText1>
              <UIText2 color="current_color">{option.description}</UIText2>
            </div>
            {/* Компонент Radio не поддерживает проп size, поэтому фиксируем мобильный вид через UiKitRoot */}
            <UiKitRoot useStaticDeviceType deviceType="phone">
              <Radio
                data-testid={`${props.name} ${option.value}`}
                name={props.name}
                value={option.value}
                onChange={e => field.onChange(e.target.value)}
                onBlur={field.onBlur}
                checked={option.value === field.value}
                disabled={props.disabled || option.disabled}
                ref={field.ref}
              />
            </UiKitRoot>
          </label>
        ))}
      </div>
    </FormField>
  );
};

RadioField.displayName = 'RadioField';
